import type { DeepPartial } from '~/types/helper.types';
import type { RoboticMowerSettings } from '~/data/Asset';
import type { RoboticMowerListItem } from '~/data/AssetListItem/AssetListItem';
import RoboticMowerSocketReasonConstants from '~/constants/robotic-mower-socket-reason-constants';
import type { RoboticMowerSocketMessage } from './types';

export const getCanUpdateMultipleAreasSupportFlag = (
  message: Pick<RoboticMowerSocketMessage, 'reason'> & {
    object?: { settings?: Pick<RoboticMowerSettings, 'supportMultipleAreas'> };
  }
) =>
  message?.object?.settings?.supportMultipleAreas !== undefined &&
  [
    RoboticMowerSocketReasonConstants.UPDATE_SETTINGS_COMMAND_SUCCESS,
    RoboticMowerSocketReasonConstants.UPDATE_SETTINGS_COMMAND_FAIL,
  ].includes(message.reason);

export const mapRoboticMowerSocketMessage = (
  message: RoboticMowerSocketMessage
): DeepPartial<RoboticMowerListItem> => {
  const { validCommands, settings, maintenanceReminder } = message.object;

  return {
    maintenanceReminder,
    roboticMower: {
      validCommands,
      // @ts-ignore
      ...(getCanUpdateMultipleAreasSupportFlag(message)
        ? { supportMultipleAreas: settings.supportMultipleAreas }
        : {}),
    },
  };
};
